module.exports = __webpack_public_path__ + "img/img-main-bg-09-m.181cd7c4.svg";